import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { MIGRATE_STACK_VENDOR } from "./gql";

const useMigrateStackVendor = createDefaultMutationHook(MIGRATE_STACK_VENDOR);

export default useMigrateStackVendor;
